import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";

// Confirm the freshly-loaded web bundle booted OK. If a just-applied OTA bundle
// never reaches this call (crashed on boot), Capawesome Live Update rolls back to
// the last-good bundle after `readyTimeout` (see capacitor.config.ts). No-op on
// web/electron. Dynamic import so the native plugin is only pulled on Android.
if (window.Capacitor?.isNativePlatform?.()) {
  import("@capawesome/capacitor-live-update")
    .then(({ LiveUpdate }) => LiveUpdate.ready())
    .catch(() => {
      /* plugin unavailable — nothing to confirm */
    });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
